import { Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';

// types
import type { ColumnProps } from '..';

// components
import { Headline } from 'components/ContentElementsGdds/headline/headline';
import { CmsLink } from 'components/Link/CmsLink';
import ImageVideo from './image-video';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { isEmpty } from 'utils/is-empty';
import { decodingContent } from 'utils/decodingContent';
import { previewId } from 'utils/preview-id';
import { useNord } from 'utils/hooks/use-nord';
import { useKolo } from 'utils/hooks/use-kolo';
import { useTwyford } from 'utils/hooks/use-twyford';
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';

function Column({
  subline,
  text,
  link,
  toggleVideoModal,
  previewId: previewIdValue,
  image,
  video,
  childOf,
  ...props
}: Readonly<ColumnProps>) {
  const hasMedia = image || !isEmpty(video);
  const isKolo = useKolo();
  const isTwyford = useTwyford();
  const isNord = useNord();
  const isOnlyNord = isNord && !isKolo && !isTwyford;
  const isChildOfAccordionOrTab = childOf && ['tab', 'accordion'].includes(childOf);

  return (
    <Col size={[4, 4, 6]} className={styles.singleCol}>
      <div {...previewId(previewIdValue)}>
        <div {...previewId(previewIdValue ? '#0' : undefined)}>
          {hasMedia && (
            <ImageVideo media={[{ video, ...props }]} toggleVideoModal={toggleVideoModal} />
          )}
          {subline && (
            <Headline
              isFlexItem
              title={decodingContent(subline)}
              tag={isChildOfAccordionOrTab ? Formats.h5 : Formats.h3}
              variant={isOnlyNord ? Formats.h5 : Formats.h3}
              titlePreviewId="#st_subline"
              className={styles.columnHeadline}
            />
          )}
          {text && (
            <InnerHtml
              as="div"
              previewId="#st_text"
              className={styles.content}
              content={text.replace(/\n/g, '<br />')}
            />
          )}
          {link && <CmsLink link={link} stylingType="primary" />}
        </div>
      </div>
    </Col>
  );
}

export default Column;
